/**
 * The ONE definition of the `getUserVideoState` query key.
 *
 * Every consumer of watch progress must build its input through here. The
 * player writes optimistic progress rows into this cache entry on a 30s
 * throttle, so a consumer that assembles a slightly different input silently
 * gets its OWN entry: same data on first fetch, then frozen — it never sees a
 * write again, and only a refetch makes it agree. There is no error and
 * nothing looks broken; the numbers just stop moving.
 *
 * That is not hypothetical. The To Do rail shipped passing `actingAsUserId`
 * (always a real user id) where this passes `undefined` when nobody is being
 * impersonated, which is a different key — so the rail's watch percentages
 * froze the moment the drawer mounted while the queue's kept updating.
 *
 * `viewAsUserId` is purely a client-side cache discriminator: the server scopes
 * by `ctx.getUser()` and ignores the field. It exists so switching
 * impersonation targets can't serve the previous target's rows synchronously.
 */
export function videoStateQueryInput(
  roundId: string,
  viewAsUserId: string | null,
): { roundId: string; viewAsUserId: string | undefined } {
  return { roundId, viewAsUserId: viewAsUserId ?? undefined };
}
